{
  "auth.changePassword.confirmPasswordLabel": "确认新密码",
  "auth.changePassword.confirmPasswordPlaceholder": "请再次输入新密码",
  "auth.changePassword.currentPasswordLabel": "当前密码",
  "auth.changePassword.currentPasswordPlaceholder": "请输入当前密码",
  "auth.changePassword.error.currentPasswordIncorrect": "当前密码不正确。",
  "auth.changePassword.error.passwordMismatch": "两次输入的密码不一致。",
  "auth.changePassword.error.samePassword": "新密码不能与当前密码相同。",
  "auth.changePassword.headerTitle": "修改密码",
  "auth.changePassword.newPasswordLabel": "新密码",
  "auth.changePassword.newPasswordPlaceholder": "请输入新密码",
  "auth.changePassword.submit": "修改密码",
  "auth.changePassword.subtitle": "您的账户使用的是临时密码，请设置新密码以继续。",
  "auth.changePassword.success": "密码修改成功。",
  "auth.changePassword.title": "修改密码",
  "auth.forgotPassword.emailLabel": "电子邮箱",
  "auth.forgotPassword.emailPlaceholder": "you@example.com",
  "auth.forgotPassword.goBack": "返回",
  "auth.forgotPassword.headerTitle": "忘记密码",
  "auth.forgotPassword.sendCode": "发送验证码",
  "auth.forgotPassword.subtitle": "请输入与您账户关联的电子邮箱地址，我们将向您发送重置密码的验证码。",
  "auth.forgotPassword.title": "忘记密码",
  "auth.login.emailLabel": "电子邮箱",
  "auth.login.emailPlaceholder": "you@example.com",
  "auth.login.error.expiredOtp": "验证码已过期，请重新申请。",
  "auth.login.error.invalidEmail": "请输入有效的电子邮箱地址。",
  "auth.login.error.invalidToken": "邀请链接无效或已过期。",
  "auth.login.error.wrongPassword": "邮箱或密码不正确。",
  "auth.login.forgotPassword": "忘记密码？",
  "auth.login.headerTitle": "欢迎回来",
  "auth.login.heading": "欢迎回来",
  "auth.login.noSms": "我们从不通过短信发送验证码。",
  "auth.login.otpLabel": "一次性验证码",
  "auth.login.otpPlaceholder": "请输入发送至邮箱的验证码",
  "auth.login.otpSent": "验证码已发送至您的邮箱。",
  "auth.login.passwordLabel": "密码",
  "auth.login.passwordPlaceholder": "请输入密码",
  "auth.login.sendOtp": "发送验证码",
  "auth.login.submit": "登录",
  "auth.login.subtitle": "登录以安全访问您的申请。",
  "auth.login.tabOtp": "邮箱验证码",
  "auth.login.tabPassword": "密码登录",
  "auth.login.title": "登录",
  "auth.otp.error.expired": "验证码已过期，请重新申请。",
  "auth.otp.error.invalid": "您输入的验证码不正确。",
  "auth.otp.getHelp": "获取帮助",
  "auth.otp.headerTitle": "验证",
  "auth.otp.heading": "验证您的邮箱",
  "auth.otp.resend": "重新发送",
  "auth.otp.resendCooldown": "{seconds}秒后重新发送",
  "auth.otp.resendPrompt": "没有收到验证码？",
  "auth.otp.submit": "登录",
  "auth.otp.subtitle": "请输入发送至您邮箱的6位验证码",
  "auth.otp.title": "验证",
  "auth.otpVerification.didntGetCode": "没有收到验证码？",
  "auth.otpVerification.error.expiredCode": "该验证码已过期，请重新申请。",
  "auth.otpVerification.error.invalidCode": "您输入的验证码不正确。",
  "auth.otpVerification.getHelp": "获取帮助",
  "auth.otpVerification.headerTitle": "验证",
  "auth.otpVerification.resendCode": "重新发送",
  "auth.otpVerification.submit": "登录",
  "auth.otpVerification.subtitle": "请输入发送至您邮箱的6位验证码",
  "auth.otpVerification.title": "验证您的邮箱",
  "auth.resetPassword.confirmPasswordLabel": "确认新密码",
  "auth.resetPassword.confirmPasswordPlaceholder": "请再次输入新密码",
  "auth.resetPassword.contactSupport": "联系支持",
  "auth.resetPassword.needHelp": "需要帮助？",
  "auth.resetPassword.newPasswordLabel": "新密码",
  "auth.resetPassword.newPasswordPlaceholder": "请输入新密码",
  "auth.resetPassword.submit": "重置密码",
  "auth.resetPassword.subtitle": "请创建一个您未曾使用过的强密码。",
  "auth.resetPassword.success": "密码已成功重置。",
  "auth.resetPassword.title": "重置密码",
  "auth.resetPassword.verifyEmail.contactSupport": "联系支持",
  "auth.resetPassword.verifyEmail.needHelp": "需要帮助？",
  "auth.resetPassword.verifyEmail.heading": "验证您的邮箱",
  "auth.resetPassword.verifyEmail.submit": "验证",
  "auth.resetPassword.verifyEmail.subtitle": "请输入发送至您邮箱的6位验证码以验证身份。",
  "auth.register.alreadyHaveAccount": "已有账户？立即登录",
  "auth.register.alreadyHaveAccountLabel": "立即登录",
  "auth.register.alreadyHaveAccountPrefix": "已有账户？",
  "auth.register.emailLabel": "电子邮箱",
  "auth.register.emailReadOnly": "您的邮箱已从邀请中预填，不可更改。",
  "auth.register.error.invalidInvite": "此邀请链接无效或已被使用。",
  "auth.register.error.passwordComplexity": "密码必须包含大写字母、小写字母和数字。",
  "auth.register.error.passwordTooLong": "密码不得超过32个字符。",
  "auth.register.error.passwordTooShort": "密码至少需要8个字符。",
  "auth.register.firstNameLabel": "名",
  "auth.register.firstNamePlaceholder": "名",
  "auth.register.firstNameRequired": "名为必填项。",
  "auth.register.headerTitle": "创建账户",
  "auth.register.infoPanelStep1Desc": "请提供贵公司授权法定代表人的详细信息。",
  "auth.register.infoPanelStep1Title": "法定代表人及联系方式",
  "auth.register.infoPanelStep2Desc": "请按照法律文件的记载，提供贵公司的官方注册信息。",
  "auth.register.infoPanelStep2Title": "核心业务信息",
  "auth.register.infoPanelStep3Desc": "说明您的销售品类，并提交合规证书。",
  "auth.register.infoPanelStep3Title": "产品与合规信息",
  "auth.register.infoPanelStep4Desc": "安全地设置您的收款方式，以便收取款项。",
  "auth.register.infoPanelStep4Title": "结算方式",
  "auth.register.infoPanelStep5Desc": "最后，请定义您的品牌形象和视觉资产。",
  "auth.register.infoPanelStep5Title": "品牌与本地化",
  "auth.register.infoPanelTitle": "我们需要审核您的申请材料",
  "auth.register.lastNameLabel": "姓",
  "auth.register.lastNamePlaceholder": "姓",
  "auth.register.lastNameRequired": "姓为必填项。",
  "auth.register.passwordHint": "8–32个字符，至少包含一个大写字母、一个小写字母和一个数字。",
  "auth.register.passwordLabel": "创建密码",
  "auth.register.passwordPlaceholder": "创建密码",
  "auth.register.privacyLink": "隐私政策",
  "auth.register.questionsText": "对申请要求有任何疑问？",
  "auth.register.submit": "创建账户",
  "auth.register.subtitle": "设置您的账户以开始供应商申请流程。",
  "auth.register.termsLink": "服务条款",
  "auth.register.termsMid": "和",
  "auth.register.termsPrefix": "点击\"创建账户\"，即表示您同意 AladdinMiles 的",
  "auth.register.termsText": "点击\"创建账户\"，即表示您同意 AladdinMiles 的{termsLink}和{privacyLink}。",
  "auth.register.title": "创建账户",
  "common.back": "上一步",
  "common.cancel": "取消",
  "common.changeFile": "更换",
  "common.clearSearch": "清除搜索",
  "common.close": "关闭",
  "common.confirm": "确认",
  "common.contactSupport": "联系支持",
  "common.disabled": "已禁用",
  "common.error.generic": "出现错误，请重试。",
  "common.error.network": "网络错误，请检查您的连接。",
  "common.error.unauthorized": "您无权执行此操作。",
  "common.error.uploadRequired": "文件上传为必填项",
  "common.footer.copyright": "© 2026 AladdinMiles",
  "common.footer.helpCenter": "帮助中心",
  "common.footer.privacyPolicy": "隐私政策",
  "common.footer.termsOfService": "服务条款",
  "common.goToDashboard": "前往控制台",
  "common.language.ar": "阿拉伯语",
  "common.language.en": "英文",
  "common.language.zh": "中文（简体）",
  "common.learnMore": "了解更多",
  "common.loading": "加载中…",
  "common.logout": "退出登录",
  "profile.title": "个人资料",
  "profile.fullName": "全名",
  "profile.email": "电子邮件",
  "profile.role": "角色",
  "profile.vendorStatus": "申请状态",
  "profile.vendorStatus.pending_registration": "待注册",
  "profile.vendorStatus.pending_application": "待申请",
  "profile.vendorStatus.pending_review": "审核中",
  "profile.vendorStatus.approved": "已批准",
  "profile.vendorStatus.rejected": "已拒绝",
  "profile.vendorStatus.update_required": "需要更新",
  "profile.section.account": "账户",
  "profile.section.preferences": "偏好设置",
  "profile.submittedDocuments": "已提交文件",
  "profile.changePassword": "修改密码",
  "profile.changePassword.successToast": "您的密码已成功更改。您现在可以使用新密码登录。",
  "profile.changePassword.oldPasswordLabel": "旧密码",
  "profile.changePassword.oldPasswordPlaceholder": "请输入旧密码",
  "profile.changePassword.submit": "重置密码",
  "profile.getHelp": "获取帮助",
  "common.next": "下一步",
  "common.noCountriesFound": "未找到国家",
  "common.notifications": "通知",
  "common.optional": "选填",
  "common.qrNotScanned": "尚未扫描二维码",
  "common.qrScanned": "二维码已扫描",
  "common.relativeTime.daysFuture": "{n}天后",
  "common.relativeTime.daysPast": "{n}天前",
  "common.relativeTime.hoursFuture": "{n}小时后",
  "common.relativeTime.hoursPast": "{n}小时前",
  "common.relativeTime.justNow": "刚刚",
  "common.relativeTime.minutesFuture": "{n}分钟后",
  "common.relativeTime.minutesPast": "{n}分钟前",
  "common.relativeTime.secondsFuture": "{n}秒后",
  "common.relativeTime.secondsPast": "{n}秒前",
  "common.required": "必填",
  "common.rescanQR": "重新扫描",
  "common.save": "保存",
  "common.saveDraft": "保存草稿",
  "common.scanQR": "扫描二维码",
  "common.search": "搜索",
  "common.searchCountriesPlaceholder": "搜索国家…",
  "common.selectFile": "选择文件",
  "common.selectOption": "请选择",
  "common.submit": "提交",
  "common.table.empty.description": "当前表格暂无可显示的数据。",
  "common.table.empty.title": "暂无数据",
  "common.table.showing": "显示 {from} 到 {to} 项，共 {total} 项",
  "common.uploadError": "上传失败，请重试。",
  "common.uploadSuccess": "上传成功",
  "common.uploading": "上传中…",
  "common.view": "查看",
  "countryDialCodePicker.a11y.code": "国家代码：{flag} {dialCode}",
  "countryDialCodePicker.title": "选择国家区号",
  "countryPicker.a11y.country": "国家：{name}",
  "countryPicker.title": "选择国家",
  "dev.logout": "DEV: 退出登录",
  "emptyState.description": "暂无可显示的项目。",
  "emptyState.title": "暂无内容",
  "errorState.description": "发生意外错误，请重试。",
  "errorState.retry": "重试",
  "errorState.title": "出错了",
  "fileUpload.a11y.uploadFile": "上传文件",
  "fileUpload.acceptedFormats": "PDF、PNG 或 JPG（最大 {maxSize}MB）",
  "fileUpload.acceptedFormatsNoSize": "PDF、PNG 或 JPG",
  "fileUpload.andAttachFiles": "并附加文件",
  "fileUpload.clickToUpload": "点击上传",
  "fileUpload.uploadFailed": "上传失败，请点击重试。",
  "fileUpload.viewDocument": "查看文件",
  "filePreview.error": "无法加载预览",
  "filePreview.errorDescription": "文件无法显示，请重试。",
  "filePreview.loading": "正在加载预览…",
  "imageUpload.a11y.uploadImages": "上传图片",
  "imageUpload.addMore": "添加更多图片",
  "imageUpload.clickToUpload": "点击上传",
  "imageUpload.maxImages": "PNG 或 JPG（最多 {count} 张）",
  "imageUpload.orDragAndDrop": "或拖放至此",
  "imageUpload.removeImage": "删除图片 {index}",
  "imageUpload.uploading": "正在上传图片…",
  "infoCard.approval.description": "申请通常在提交后 1–2 个工作日内完成审核。",
  "infoCard.approval.title": "快速审核",
  "infoCard.assist.description": "我们的入驻团队在 CST 上午 9 点至下午 6 点随时为您提供帮助。",
  "infoCard.assist.title": "需要帮助？",
  "infoCard.secure.description": "您的数据已加密，未经您的同意不会与第三方共享。",
  "infoCard.secure.title": "安全与保密",
  "invite.landing.invalidLink": "该邀请链接无效或已过期，请联系您的管理员。",
  "invite.landing.invalidLinkTitle": "无效邀请",
  "invite.landing.mobileOption.hint": "我们将为您显示一个二维码供扫描",
  "invite.landing.mobileOption.title": "下载移动应用",
  "invite.landing.mobileOption.titleShort": "下载应用",
  "invite.landing.or": "或",
  "invite.landing.qrModal.subtitle": "用手机扫描下方二维码",
  "invite.landing.qrModal.title": "下载 AladdinMiles 应用",
  "invite.landing.title": "您已收到邀请",
  "invite.landing.verifying": "正在验证您的邀请…",
  "invite.landing.webOption.title": "继续在网页上操作",
  "l10n.dashboard.discardChanges": "放弃更改",
  "l10n.dashboard.empty": "未找到相关条目。",
  "l10n.dashboard.language.ar": "阿拉伯语",
  "l10n.dashboard.language.en": "English",
  "l10n.dashboard.language.zh-CN": "中文（简体）",
  "l10n.dashboard.saveChanges": "保存更改",
  "l10n.dashboard.title": "本地化管理",
  "language.ar": "العربية",
  "language.en": "English",
  "language.switcher.label": "语言",
  "language.zh-CN": "中文",
  "multiSelectPicker.allCategories": "所有类别",
  "multiSelectPicker.allIndustries": "所有行业",
  "multiSelectPicker.noResults": "未找到结果",
  "multiSelectPicker.remove": "移除",
  "multiSelectPicker.saveSelection": "保存选择",
  "multiSelectPicker.searchCategories": "搜索类别名称",
  "multiSelectPicker.searchIndustries": "搜索行业名称",
  "multiSelectPicker.selectAll": "全选",
  "multiSelectPicker.selectedCategories": "已选类别",
  "multiSelectPicker.selectedCategoriesCount": "您已选择 {count} 个产品类别",
  "multiSelectPicker.selectedIndustries": "已选行业",
  "multiSelectPicker.selectedIndustriesCount": "您已选择 {count} 个行业",
  "multiSelectPicker.switchToChinese": "切换 Switch to Chinese",
  "multiSelectPicker.switchToEnglish": "ABC Switch to English",
  "notFound.description": "您查找的页面不存在或无法访问。",
  "notFound.goHome": "返回首页",
  "notFound.heading": "页面未找到",
  "notFound.screenTitle": "未找到",
  "placeholder.activity.description": "您将在此处查看申请和账户的更新。",
  "placeholder.activity.title": "动态",
  "placeholder.home.description": "您的概览仪表盘将显示在此处。",
  "placeholder.home.title": "首页",
  "placeholder.profile.description": "您的个人资料设置将显示在此处。",
  "placeholder.profile.title": "个人资料",
  "portal.dashboard.allInvitationsSent": "已发送所有邀请",
  "portal.dashboard.applications": "申请",
  "portal.dashboard.applicationsSubmitted": "已提交申请数",
  "portal.dashboard.approved": "已批准",
  "portal.dashboard.filter.custom": "自定义",
  "portal.dashboard.filter.last24Hours": "过去24小时",
  "portal.dashboard.filter.last30Days": "过去30天",
  "portal.dashboard.filter.last7Days": "过去7天",
  "portal.dashboard.invitations": "邀请",
  "portal.dashboard.invited": "已邀请",
  "portal.dashboard.newInvitations": "新邀请",
  "portal.dashboard.overview": "总览",
  "portal.dashboard.pendingReview": "待审核",
  "portal.dashboard.recentApplications": "最近申请",
  "portal.dashboard.rejected": "已拒绝",
  "portal.dashboard.resentInvitations": "已重发邀请",
  "portal.dashboard.reviewApplication": "审查申请",
  "portal.dashboard.subtitle": "供应商申请与邀请的活动概览。",
  "portal.dashboard.table.companyName": "公司名称",
  "portal.dashboard.table.lastActivity": "最近活动",
  "portal.dashboard.table.primaryContact": "主要联系人",
  "portal.dashboard.table.primaryIndustry": "主要行业",
  "portal.dashboard.table.status": "状态",
  "portal.dashboard.viewAllApplications": "查看所有申请",
  "portal.nav.activity": "动态",
  "portal.nav.adminUsers": "管理员",
  "portal.nav.application": "申请",
  "portal.nav.applications": "申请",
  "portal.nav.home": "首页",
  "portal.nav.invitations": "邀请",
  "portal.nav.overview": "总览",
  "portal.nav.profile": "个人",
  "preVetting.draftSaved": "草稿已保存。",
  "preVetting.goBack": "返回",
  "preVetting.step1.contactEmail": "企业邮箱",
  "preVetting.step1.contactPhone": "联系电话",
  "preVetting.step1.contactPhonePlaceholder": "+86 000 0000 0000",
  "preVetting.step1.department": "部门",
  "preVetting.step1.error.idDocumentRequired": "证件文件为必填项。",
  "preVetting.step1.error.invalidEmail": "请输入有效的电子邮件地址。",
  "preVetting.step1.error.invalidPhone": "请输入有效的E.164格式电话号码。",
  "preVetting.step1.error.wechatQrNull": "微信二维码无法解析，请重新扫描。",
  "preVetting.step1.idDocument": "上传证件",
  "preVetting.step1.idType": "证件类型",
  "preVetting.step1.idType.nationalId": "居民身份证",
  "preVetting.step1.idType.passport": "护照",
  "preVetting.step1.idType.other": "其他",
  "preVetting.step1.legalNameChinese": "法人姓名（中文）",
  "preVetting.step1.legalNameEnglish": "法人姓名（英文）",
  "preVetting.step1.nationality": "国籍",
  "preVetting.step1.nextLabel": "添加业务信息",
  "preVetting.step1.roleInCompany": "职位",
  "preVetting.step1.shortLabel": "法定代表人",
  "preVetting.step1.subtitle": "请提供贵企业授权法人代表的详细信息。",
  "preVetting.step1.title": "法人代表及联系方式",
  "preVetting.step1.wechatQr": "联系人微信二维码",
  "preVetting.step2.businessLicense": "营业执照",
  "preVetting.step2.companyNameArabic": "公司名称（阿拉伯文）",
  "preVetting.step2.companyNameArabicOptional": "公司名称（阿拉伯文）（可选）",
  "preVetting.step2.companyNameChinese": "公司名称（中文）",
  "preVetting.step2.companyNameEnglish": "公司名称（英文）",
  "preVetting.step2.error.businessLicenseRequired": "营业执照文件为必填项。",
  "preVetting.step2.error.taxNumberLength": "必须为15–20位字母或数字。",
  "preVetting.step2.error.unifiedCodeFormat": "统一社会信用代码只能包含数字和大写字母。",
  "preVetting.step2.error.unifiedCodeLength": "必须为18位字母或数字。",
  "preVetting.step2.hqAddress": "总部地址",
  "preVetting.step2.hqCity": "城市",
  "preVetting.step2.hqPostalCode": "邮政编码",
  "preVetting.step2.nextLabel": "添加产品与合规信息",
  "preVetting.step2.sectionHqAddress": "总部地址",
  "preVetting.step2.shortLabel": "业务信息",
  "preVetting.step2.subtitle": "请提供贵机构在法律文件中显示的官方注册信息。",
  "preVetting.step2.taxRegistrationNumber": "税务登记号",
  "preVetting.step2.title": "核心企业信息",
  "preVetting.step2.unifiedSocialCreditCode": "统一社会信用代码",
  "preVetting.step3.addCategory": "添加类别",
  "preVetting.step3.addIndustry": "添加行业",
  "preVetting.step3.ceMarking": "CE认证",
  "preVetting.step3.ceMarkingHint": "欧盟健康、安全和环境保护",
  "preVetting.step3.ceMarkingOptional": "CE认证标志",
  "preVetting.step3.declaration": "本人特此声明，以上提供的信息真实准确，上传的文件均为真实文件。本人了解，任何虚假材料将导致立即暂停平台使用权限。",
  "preVetting.step3.ecoCertHint": "FSC、GOTS 或公平贸易认证",
  "preVetting.step3.ecoCertification": "环保认证",
  "preVetting.step3.ecoCertificationOptional": "环保/可持续发展认证",
  "preVetting.step3.error.industryRequired": "请至少选择一个行业。",
  "preVetting.step3.error.subcategoryRequired": "请至少选择一个产品类别。",
  "preVetting.step3.industries": "经营行业（选择所有适用项）",
  "preVetting.step3.industriesHint": "请至少选择一个行业。",
  "preVetting.step3.isoCertHint": "质量管理体系证明",
  "preVetting.step3.isoCertification": "ISO认证",
  "preVetting.step3.isoCertificationOptional": "ISO 9001认证",
  "preVetting.step3.nextLabel": "添加财务结算信息",
  "preVetting.step3.productSubcategories": "产品类别（选择所有适用项）",
  "preVetting.step3.productSubcategoriesHint": "请至少选择一个产品子类别。",
  "preVetting.step3.qualityReportHint": "近期第三方实验室检测报告",
  "preVetting.step3.qualityTestReport": "质量检测报告",
  "preVetting.step3.qualityTestReportOptional": "质量测试报告",
  "preVetting.step3.sectionCompliance": "合规认证",
  "preVetting.step3.shortLabel": "产品与合规",
  "preVetting.step3.subtitle": "添加您计划销售的产品类别并上传合规证书。",
  "preVetting.step3.title": "产品及合规信息",
  "preVetting.step4.alipay.accountEmail": "支付宝账户邮箱",
  "preVetting.step4.alipay.accountHolderName": "账户持有人姓名",
  "preVetting.step4.alipay.isUnderLegalEntityName": "账户在法律实体名下",
  "preVetting.step4.alipay.merchantId": "支付宝商户ID",
  "preVetting.step4.alipay.qrCode": "支付宝商家二维码",
  "preVetting.step4.alipay.settlementCurrency": "结算货币",
  "preVetting.step4.alipay.title": "支付宝信息",
  "preVetting.step4.bank.accountHolderName": "账户持有人姓名",
  "preVetting.step4.bank.accountNumber": "账户号码",
  "preVetting.step4.bank.bankAddress": "银行地址",
  "preVetting.step4.bank.bankName": "银行名称",
  "preVetting.step4.bank.ibanCode": "IBAN",
  "preVetting.step4.bank.isUnderLegalEntityName": "账户在法律实体名下",
  "preVetting.step4.bank.settlementCurrency": "结算货币",
  "preVetting.step4.bank.swiftCode": "SWIFT / BIC代码",
  "preVetting.step4.bank.title": "银行信息",
  "preVetting.step4.bank.withdrawConsent": "撤回付款授权",
  "preVetting.step4.corporateAccountNote": "请确保您的付款账户以与企业相同的法律实体名称注册。",
  "preVetting.step4.error.alipayRequired": "选择支付宝时，支付宝详情为必填项。",
  "preVetting.step4.error.bankRequired": "选择银行转账时，银行详情为必填项。",
  "preVetting.step4.error.channelRequired": "请至少选择一种支付渠道。",
  "preVetting.step4.error.wechatPayRequired": "选择微信支付时，微信支付详情为必填项。",
  "preVetting.step4.nextLabel": "添加品牌信息",
  "preVetting.step4.paymentChannels": "支付渠道",
  "preVetting.step4.paymentChannelsHint": "请至少选择一个支付渠道。",
  "preVetting.step4.selectChannelsLabel": "选择您希望接收付款的支付渠道",
  "preVetting.step4.shortLabel": "财务结算",
  "preVetting.step4.subtitle": "请提供贵公司的财务信息以安全接收结算款项。",
  "preVetting.step4.title": "财务结算",
  "preVetting.step4.wechatPay.accountEmail": "账户邮箱",
  "preVetting.step4.wechatPay.accountHolderName": "账户持有人姓名",
  "preVetting.step4.wechatPay.accountType": "账户类型",
  "preVetting.step4.wechatPay.error.qrNull": "微信支付二维码无法解析，请重新扫描。",
  "preVetting.step4.wechatPay.merchantId": "微信支付商户ID",
  "preVetting.step4.wechatPay.qrCode": "微信支付二维码",
  "preVetting.step4.wechatPay.settlementCurrency": "结算货币",
  "preVetting.step4.wechatPay.title": "微信支付信息",
  "preVetting.step5.businessLogo": "企业Logo",
  "preVetting.step5.descriptionArabic": "企业简介（阿拉伯文）",
  "preVetting.step5.descriptionArabicOptional": "企业简介（阿拉伯文）（可选）",
  "preVetting.step5.descriptionEnglish": "企业简介（英文）",
  "preVetting.step5.error.descriptionTooShort": "描述至少需要10个字符。",
  "preVetting.step5.error.logoRequired": "企业Logo为必填项。",
  "preVetting.step5.primaryIndustry": "主要行业",
  "preVetting.step5.shortLabel": "品牌与本地化",
  "preVetting.step5.shortNameArabic": "企业简称（阿拉伯文）",
  "preVetting.step5.shortNameArabicOptional": "企业简称（阿拉伯文）（可选）",
  "preVetting.step5.shortNameEnglish": "企业简称（英文）",
  "preVetting.step5.shortNameHint": "这将是您在 AladdinMiles 客户应用上的显示名称。",
  "preVetting.step5.subtitle": "通过提供品牌信息完成申请。",
  "preVetting.step5.title": "品牌与本地化",
  "preVetting.stepOf": "第{current}步，共{total}步",
  "preVetting.title": "供应商申请",
  "preVetting.webSubtitle": "请填写以下信息，我们的团队将审核您的申请",
  "preVetting.webTitle": "申请成为卖家",
  "review.application.activityLog.actions.approved": "审批通过了此申请。",
  "review.application.activityLog.actions.rejected": "拒绝了此申请。",
  "review.application.activityLog.actions.requested_updates": "请求对此申请进行更新。",
  "review.application.activityLog.actions.resubmitted": "提交了更新的申请。",
  "review.application.activityLog.actions.submitted": "提交了此申请。",
  "review.application.activityLog.empty": "此申请暂无活动记录。",
  "review.application.activityLog.title": "活动日志",
  "review.application.activityLog.viewRequest": "查看请求",
  "review.application.activityLogComingSoon": "活动日志内容即将来临。",
  "review.application.approve": "批准",
  "review.application.status.approved": "已批准",
  "review.application.status.pending_review": "待审核",
  "review.application.status.rejected": "已拒绝",
  "review.application.brandingLocalization.description": "显示名称和品牌资产。",
  "review.application.brandingLocalization.fields.businessLogo": "企业Logo",
  "review.application.brandingLocalization.fields.descriptionArabic": "企业简介（阿拉伯文）",
  "review.application.brandingLocalization.fields.descriptionEnglish": "企业简介（英文）",
  "review.application.brandingLocalization.fields.shortNameArabic": "企业简称（阿拉伯文）",
  "review.application.brandingLocalization.fields.shortNameChinese": "企业简称（中文）",
  "review.application.brandingLocalization.fields.shortNameEnglish": "企业简称（英文）",
  "review.application.brandingLocalization.noLogo": "未上传标志",
  "review.application.brandingLocalization.notProvided": "未提供",
  "review.application.brandingLocalization.title": "品牌与本地化",
  "review.application.businessInformation.description": "企业的官方注册信息及运营详情。",
  "review.application.businessInformation.fields.businessLicense": "营业执照",
  "review.application.businessInformation.fields.city": "城市",
  "review.application.businessInformation.fields.companyNameArabic": "公司法定名称（阿拉伯文）",
  "review.application.businessInformation.fields.companyNameChinese": "公司法定名称（中文）",
  "review.application.businessInformation.fields.companyNameEnglish": "公司法定名称（英文）",
  "review.application.businessInformation.fields.postalCode": "邮政编码",
  "review.application.businessInformation.fields.registeredAddress": "注册办公地址",
  "review.application.businessInformation.fields.taxRegistrationNumber": "税务登记号",
  "review.application.businessInformation.fields.ussc": "统一社会信用代码（USSC）",
  "review.application.businessInformation.notProvided": "未提供",
  "review.application.businessInformation.title": "商业信息",
  "review.application.companyName": "公司",
  "review.application.contentComingSoon": "{name} 的内容即将来临。",
  "review.application.edit": "编辑",
  "review.application.financialSettlement.description": "结算支付的企业财务信息。出于安全原因，部分字段已被屏蔽。",
  "review.application.financialSettlement.fields.accountHolderName": "账户持有人姓名",
  "review.application.financialSettlement.fields.alipayBusinessName": "支付宝注册企业名称",
  "review.application.financialSettlement.fields.alipayEmail": "支付宝账户邮箱",
  "review.application.financialSettlement.fields.alipayMerchantId": "支付宝商户ID",
  "review.application.financialSettlement.fields.alipayQrCode": "支付宝支付二维码",
  "review.application.financialSettlement.fields.bankAccountNumber": "银行账号",
  "review.application.financialSettlement.fields.bankAddress": "银行地址",
  "review.application.financialSettlement.fields.bankName": "银行名称",
  "review.application.financialSettlement.fields.iban": "IBAN",
  "review.application.financialSettlement.fields.settlementCurrency": "结算货币",
  "review.application.financialSettlement.fields.swiftCode": "SWIFT 代码",
  "review.application.financialSettlement.fields.wechatBusinessName": "微信支付注册企业名称",
  "review.application.financialSettlement.fields.wechatEmail": "微信支付账户邮箱",
  "review.application.financialSettlement.fields.wechatMerchantId": "微信支付商户ID",
  "review.application.financialSettlement.fields.wechatQrCode": "微信支付二维码",
  "review.application.financialSettlement.fields.wechatSettlementAccountType": "结算账户类型",
  "review.application.financialSettlement.notProvided": "未提供",
  "review.application.financialSettlement.sections.alipay": "支付宝",
  "review.application.financialSettlement.sections.bank": "银行",
  "review.application.financialSettlement.sections.wechatPay": "微信支付",
  "review.application.financialSettlement.showQrCode": "显示二维码",
  "review.application.financialSettlement.title": "财务结算",
  "review.application.legalRepresentative.description": "该企业的法定代表人的个人和识别详细信息",
  "review.application.legalRepresentative.fields.businessEmail": "商务电子邮箱",
  "review.application.legalRepresentative.fields.department": "部门",
  "review.application.legalRepresentative.fields.fullNameChinese": "法定全名（中文）",
  "review.application.legalRepresentative.fields.fullNameEnglish": "法定全名（英文）",
  "review.application.legalRepresentative.fields.legalId": "法定代表人身份证件",
  "review.application.legalRepresentative.fields.nationality": "国籍",
  "review.application.legalRepresentative.fields.phoneNumber": "电话号码",
  "review.application.legalRepresentative.fields.role": "职位",
  "review.application.legalRepresentative.fields.wechatQr": "联系人微信二维码",
  "review.application.legalRepresentative.notUploaded": "未上传",
  "review.application.legalRepresentative.passport": "护照",
  "review.application.legalRepresentative.passportPlaceholder": "护照图片占位符",
  "review.application.legalRepresentative.title": "法定代表人及联系人",
  "review.application.productCompliance.description": "产品类别、合规认证及经营行业。",
  "review.application.productCompliance.fields.ceMarking": "CE 认证",
  "review.application.productCompliance.fields.ecoCertifications": "环保认证",
  "review.application.productCompliance.fields.isoCertificate": "ISO 9001 认证",
  "review.application.productCompliance.fields.operatingCategories": "经营类别",
  "review.application.productCompliance.fields.operatingIndustries": "经营行业",
  "review.application.productCompliance.fields.qualityTestReports": "质量检测报告",
  "review.application.productCompliance.notProvided": "未提供",
  "review.application.productCompliance.title": "产品与合规",
  "review.application.productCompliance.viewDocument": "查看文件",
  "review.application.reject": "拒绝",
  "review.application.rejectionDetails.dateRejected": "拒绝日期",
  "review.application.rejectionDetails.reason": "原因",
  "review.application.rejectionDetails.rejectedBy": "拒绝人",
  "review.application.rejectionDetails.viewReason": "拒绝原因",
  "review.application.requestChanges": "要求补充材料",
  "review.application.submittedAt": "提交时间",
  "review.application.subtabs.brandingLocalization": "品牌与本地化",
  "review.application.subtabs.businessInformation": "商业信息",
  "review.application.subtabs.financialSettlement": "财务结算",
  "review.application.subtabs.legalRepresentative": "法定代表人",
  "review.application.subtabs.productCompliance": "产品及合规",
  "review.application.tabs.activityLog": "活动日志",
  "review.application.tabs.submittedInformation": "提交信息",
  "review.application.undoDecision": "撤销决定",
  "review.dashboard.empty": "暂无待审核申请。",
  "review.dashboard.status.pendingReview": "待审核",
  "review.dashboard.title": "供应商申请",
  "review.review.decision.approve": "批准申请",
  "review.review.decision.approveModal.checklist.brandAssets": "品牌资产和本地化数据完整，且符合市场规范",
  "review.review.decision.approveModal.checklist.businessRegistration": "业务登记和统一社会信用代码已与官方记录交叉核对",
  "review.review.decision.approveModal.checklist.complianceCertificates": "所有合规证书均有效、最新，且与提交的类别匹配",
  "review.review.decision.approveModal.checklist.financialSettlement": "金融结算凭证已验证，账户处于活跃状态",
  "review.review.decision.approveModal.checklist.legalIdentity": "法定代表人身份已根据提交的身份证明文件进行验证",
  "review.review.decision.approveModal.checklistNote": "请完成所有清单项目以启用批准。",
  "review.review.decision.approveModal.confirmApproval": "确认批准",
  "review.review.decision.approveModal.successDescription": "此供应商将通过电子邮件收到其申请已获批准的通知。",
  "review.review.decision.approveModal.successTitle": "供应商已批准",
  "review.review.decision.approveModal.verificationChecklist": "验证清单",
  "review.review.decision.description": "为整个申请做出决定。",
  "review.review.decision.reject": "拒绝申请",
  "review.review.decision.rejectFieldModal.internalNote": "内部备注",
  "review.review.decision.rejectFieldModal.internalNotePlaceholder": "此内容仅供内部参考，不会向供应商显示。",
  "review.review.decision.rejectFieldModal.reasonPlaceholder": "与官方记录不符。",
  "review.review.decision.rejectFieldModal.rejectedFieldLabel": "被拒绝字段",
  "review.review.decision.rejectFieldModal.title": "拒绝选定字段",
  "review.review.decision.rejectModal.reasonForRejection": "拒绝原因",
  "review.review.decision.rejectModal.reasonPlaceholder": "提交的文件中公司详情不一致。",
  "review.review.decision.rejectModal.rejectedVendor": "已拒绝供应商",
  "review.review.decision.rejectModal.submitRejection": "提交拒绝",
  "review.review.decision.rejectModal.successDescription": "供应商将通过电子邮件收到其申请已被拒绝的通知。",
  "review.review.decision.rejectModal.successTitle": "申请已拒绝",
  "review.review.decision.requestChanges": "请求更改",
  "review.review.decision.requestChangesModal.addReason": "添加原因",
  "review.review.decision.requestChangesModal.addReasons": "添加原因",
  "review.review.decision.requestChangesModal.back": "返回",
  "review.review.decision.requestChangesModal.fields.alipayBusinessName": "支付宝注册企业名称",
  "review.review.decision.requestChangesModal.fields.alipayMerchantId": "支付宝商户ID",
  "review.review.decision.requestChangesModal.fields.businessLicense": "营业执照",
  "review.review.decision.requestChangesModal.fields.businessLogo": "企业Logo",
  "review.review.decision.requestChangesModal.fields.ceMarking": "CE 认证",
  "review.review.decision.requestChangesModal.fields.companyNameEnglish": "公司名称（英文）",
  "review.review.decision.requestChangesModal.fields.descriptionEnglish": "企业描述（英文）",
  "review.review.decision.requestChangesModal.fields.ecoCertifications": "环保认证",
  "review.review.decision.requestChangesModal.fields.isoCertificate": "ISO 9001 证书",
  "review.review.decision.requestChangesModal.fields.legalRepresentativeId": "法定代表人证件",
  "review.review.decision.requestChangesModal.fields.operatingCategories": "经营类别",
  "review.review.decision.requestChangesModal.fields.operatingIndustries": "经营行业",
  "review.review.decision.requestChangesModal.fields.shortNameEnglish": "企业简称（英文）",
  "review.review.decision.requestChangesModal.fields.taxRegistrationNumber": "税务登记号",
  "review.review.decision.requestChangesModal.fields.unifiedSocialCreditCode": "统一社会信用代码",
  "review.review.decision.requestChangesModal.fields.wechatBusinessName": "微信支付注册企业名称",
  "review.review.decision.requestChangesModal.fields.wechatMerchantId": "微信支付商户ID",
  "review.review.decision.requestChangesModal.fieldsSelected": "已选字段",
  "review.review.decision.requestChangesModal.noFieldsFound": "没有与搜索条件匹配的字段。",
  "review.review.decision.requestChangesModal.noFieldsSelectedHint": "请从左侧选择需要更新的字段。",
  "review.review.decision.requestChangesModal.reasonLabel": "原因",
  "review.review.decision.requestChangesModal.reasonPlaceholder": "请说明需要更正的内容...",
  "review.review.decision.requestChangesModal.remove": "移除",
  "review.review.decision.requestChangesModal.sendChangeRequest": "发送变更请求",
  "review.review.decision.requestChangesModal.step1Subtitle": "第 1 步，共 2 步（选择需要更新的字段）",
  "review.review.decision.requestChangesModal.step2Subtitle": "第 2 步，共 2 步（为每个字段添加一个原因）",
  "review.review.decision.requestChangesModal.submitRequest": "提交请求",
  "review.review.decision.requestChangesModal.successDescription": "供应商将通过电子邮件收到有关其申请所需更改的通知。",
  "review.review.decision.requestChangesModal.successTitle": "已请求更改",
  "review.review.decision.requestChangesModal.title": "请求更改",
  "review.review.decision.requestChangesModal.youHaveSelectedCount": "您已选择 {count} 个字段",
  "review.review.decision.showDecisions": "显示决定",
  "review.review.decision.title": "申请决定",
  "review.review.editFieldModal.currentValue": "当前值",
  "review.review.editFieldModal.newValue": "新值",
  "review.review.editFieldModal.saveAccept": "保存并接受",
  "review.review.editFieldModal.title": "编辑字段",
  "review.review.fieldState.approved": "已批准",
  "review.review.fieldState.edited": "已编辑",
  "review.review.fieldState.reasonModal.dateRejected": "拒绝日期",
  "review.review.fieldState.reasonModal.edit": "编辑",
  "review.review.fieldState.reasonModal.internalNote": "内部备注",
  "review.review.fieldState.reasonModal.reason": "原因",
  "review.review.fieldState.reasonModal.rejectedBy": "拒绝者",
  "review.review.fieldState.reasonModal.title": "拒绝原因",
  "review.review.fieldState.rejected": "已拒绝",
  "review.review.fieldState.showEdit": "查看编辑",
  "review.review.fieldState.showEditModal.currentValue": "当前值",
  "review.review.fieldState.showEditModal.dateEdited": "编辑日期",
  "review.review.fieldState.showEditModal.editedBy": "编辑者",
  "review.review.fieldState.showEditModal.previousValue": "之前的值",
  "review.review.fieldState.showEditModal.undoEdit": "撤销编辑",
  "review.review.fieldState.showEditModal.update": "更新",
  "review.review.fieldState.showReason": "查看原因",
  "review.review.fieldState.undoDecision": "撤销决定",
  "review.review.fieldsAudited": "已审核 {count} 个字段",
  "review.review.reviewCompleted": "审核完成",
  "review.review.sectionProgress": "第 {current} 部分，共 {total} 部分",
  "review.review.title": "审核申请",
  "review.review.viewOnly": "仅查看",
  "roles.admin": "管理员",
  "roles.localizationStaff": "本地化专员",
  "roles.staff": "员工",
  "roles.superAdmin": "超级管理员",
  "roles.vendor": "供应商",
  "staff.applications.stats.approved": "已批准申请",
  "staff.applications.stats.approvedDesc": "24小时内批准",
  "staff.applications.stats.new": "新申请",
  "staff.applications.stats.newDesc": "24小时内提交",
  "staff.applications.stats.rejected": "已拒绝申请",
  "staff.applications.stats.rejectedDesc": "24小时内拒绝",
  "staff.applications.subtitle": "审核并处理已提交的申请",
  "staff.applications.tabs.all": "全部",
  "staff.applications.tabs.approved": "已批准",
  "staff.applications.tabs.pending": "待审核",
  "staff.applications.tabs.rejected": "已拒绝",
  "staff.applications.title": "供应商申请",
  "staff.invitations.actions.resendInvite": "重新发送邀请",
  "staff.invitations.actions.sendInvitation": "发送邀请",
  "staff.invitations.detail.activityLog": "操作日志",
  "staff.invitations.detail.activityResent": "{name} 向该收件人重发了邀请。",
  "staff.invitations.detail.activitySent": "{name} 向该收件人发送了邀请。",
  "staff.invitations.detail.breadcrumb": "邀请管理",
  "staff.invitations.detail.invitationDetails": "邀请详情",
  "staff.invitations.detail.lastInvitationDate": "上次邀请日期",
  "staff.invitations.detail.lastInvitedBy": "上次邀请人",
  "staff.invitations.detail.quickTip": "快速提示",
  "staff.invitations.detail.quickTipBody": "如果收件人未收到邮件，请让其检查垃圾邮件文件夹，或确认邮箱地址是否正确。",
  "staff.invitations.detail.recipientEmail": "收件人电子邮箱",
  "staff.invitations.detail.recipientName": "收件人姓名",
  "staff.invitations.detail.resendCount": "重发次数",
  "staff.invitations.detail.resendInvite": "重新发送邀请",
  "staff.invitations.detail.sentAgo": "已于 {time} 发送（{date}）",
  "staff.invitations.empty": "尚未发送任何邀请。",
  "staff.invitations.resend.body": "确定要向 {email} 重新发送邀请吗？",
  "staff.invitations.resend.cancel": "取消",
  "staff.invitations.resend.confirm": "确认",
  "staff.invitations.resend.languageLabel": "邀请语言",
  "staff.invitations.resend.languagePlaceholder": "选择语言",
  "staff.invitations.resend.success": "邀请已重发！",
  "staff.invitations.resend.successBody": "邀请邮件已成功重新发送。",
  "staff.invitations.resend.title": "重新发送邀请",
  "staff.invitations.send.cancel": "取消",
  "staff.invitations.send.emailLabel": "电子邮箱",
  "staff.invitations.send.emailPlaceholder": "输入供应商电子邮箱",
  "staff.invitations.send.firstNameLabel": "名字（可选）",
  "staff.invitations.send.firstNamePlaceholder": "输入名字",
  "staff.invitations.send.inviteVendorSubtitle": "将向收件人的电子邮箱发送唯一的注册链接",
  "staff.invitations.send.inviteVendorTitle": "邀请供应商",
  "staff.invitations.send.languageLabel": "邀请语言",
  "staff.invitations.send.languagePlaceholder": "选择语言",
  "staff.invitations.send.lastNameLabel": "姓氏（可选）",
  "staff.invitations.send.lastNamePlaceholder": "输入姓氏",
  "staff.invitations.send.messageLabel": "个人消息（可选）",
  "staff.invitations.send.messagePlaceholder": "添加个人消息到邀请…",
  "staff.invitations.send.sendInvite": "发送邀请",
  "staff.invitations.send.submit": "发送邀请",
  "staff.invitations.send.success": "邀请已发送！",
  "staff.invitations.send.successBody": "此收件人将收到一封包含唯一注册链接的电子邮件，以开始其申请。",
  "staff.invitations.send.title": "发送邀请",
  "staff.invitations.stats.new": "新邀请",
  "staff.invitations.stats.newDesc": "24小时内发送",
  "staff.invitations.stats.total": "邀请总数",
  "staff.invitations.stats.totalDesc": "已发送的所有邀请",
  "staff.invitations.subtitle": "管理和跟踪发送给供应商的邀请",
  "staff.invitations.table.dateInvited": "邀请日期",
  "staff.invitations.table.invitedBy": "邀请人",
  "staff.invitations.table.recipient": "收件人",
  "staff.invitations.table.showing": "显示第 {from} 至 {to} 条，共 {total} 条",
  "staff.invitations.tabs.all": "全部邀请",
  "staff.invitations.tabs.resent": "已重发邀请",
  "staff.invitations.title": "邀请管理",
  "staff.localization.actions.addContent": "添加内容",
  "staff.localization.actions.filter": "筛选",
  "staff.localization.actions.sort": "排序",
  "staff.localization.addContent.arabicLabel": "阿拉伯语翻译",
  "staff.localization.addContent.cancel": "取消",
  "staff.localization.addContent.chineseLabel": "中文翻译",
  "staff.localization.addContent.contentTypeCategories": "产品分类",
  "staff.localization.addContent.contentTypeIndustries": "产品行业",
  "staff.localization.addContent.contentTypeLabel": "内容类型",
  "staff.localization.addContent.contentTypeOther": "其他内容",
  "staff.localization.addContent.contentTypePlaceholder": "选择内容类型",
  "staff.localization.addContent.englishLabel": "英语翻译",
  "staff.localization.addContent.infoText": "添加所有翻译后，此内容将变为已完成。",
  "staff.localization.addContent.keyLabel": "键标题",
  "staff.localization.addContent.keyPlaceholder": "例如: common.save",
  "staff.localization.addContent.pending": "待处理",
  "staff.localization.addContent.submit": "添加内容",
  "staff.localization.addContent.success": "内容已添加",
  "staff.localization.addContent.successBody": "您已成功将新内容添加到本地化字典。",
  "staff.localization.addContent.error": "添加内容失败",
  "staff.localization.addContent.errorBody": "添加内容时出现问题，请重试。",
  "staff.localization.addContent.title": "添加新内容",
  "staff.localization.addContent.translationsHeader": "翻译",
  "staff.localization.card.completed": "已完成",
  "staff.localization.card.lastEdited": "最后编辑",
  "staff.localization.card.moreInfo": "更多信息",
  "staff.localization.card.pending": "待处理",
  "staff.localization.detail.activityLog": "活动日志",
  "staff.localization.detail.activityAction.add": "添加了翻译",
  "staff.localization.detail.activityAction.edit": "编辑了翻译",
  "staff.localization.detail.activityAction.delete": "删除了翻译",
  "staff.localization.detail.arabic": "阿拉伯语",
  "staff.localization.detail.breadcrumb": "本地化",
  "staff.localization.detail.chinese": "中文",
  "staff.localization.detail.contentType": "内容类型",
  "staff.localization.detail.contentTypeCategories": "产品分类",
  "staff.localization.detail.contentTypeIndustries": "产品行业",
  "staff.localization.detail.contentTypeOther": "其他内容",
  "staff.localization.detail.editTranslation": "编辑翻译",
  "staff.localization.detail.editTranslations": "编辑翻译",
  "staff.localization.detail.english": "英语",
  "staff.localization.detail.keyTitle": "键标题",
  "staff.localization.detail.language": "语言",
  "staff.localization.detail.title": "翻译详情",
  "staff.localization.detail.translation": "翻译",
  "staff.localization.filter.statusAll": "全部",
  "staff.localization.filter.statusCompleted": "已完成",
  "staff.localization.filter.statusPending": "待处理",
  "staff.localization.filter.title": "状态",
  "staff.localization.modal.arabicLabel": "阿拉伯语翻译",
  "staff.localization.modal.cancel": "取消",
  "staff.localization.modal.chineseLabel": "中文翻译",
  "staff.localization.modal.englishLabel": "英语翻译",
  "staff.localization.modal.keyLabel": "键标题",
  "staff.localization.modal.save": "保存",
  "staff.localization.modal.saveSuccess": "翻译已保存！",
  "staff.localization.modal.saveSuccessBody": "您已成功编辑翻译。",
  "staff.localization.modal.saveError": "保存失败",
  "staff.localization.modal.saveErrorBody": "保存翻译时出现问题，请重试。",
  "staff.localization.modal.title": "编辑翻译",
  "staff.localization.showing": "显示 {from} 到 {to}，共 {total} 条",
  "staff.localization.sort.alphaAsc": "升序 (A-Z)",
  "staff.localization.sort.alphaDesc": "降序 (Z-A)",
  "staff.localization.sort.completionStatus": "完成状态",
  "staff.localization.sort.keyName": "键名",
  "staff.localization.sort.lastEdited": "最后编辑",
  "staff.localization.sort.sectionAlpha": "字母顺序",
  "staff.localization.sort.sectionDate": "日期",
  "staff.localization.stats.allContent": "所有内容",
  "staff.localization.stats.allContentDesc": "字典中的所有内容",
  "staff.localization.stats.completed": "已完成本地化",
  "staff.localization.stats.completedDesc": "具有完整翻译的内容",
  "staff.localization.stats.pending": "待处理本地化",
  "staff.localization.stats.pendingDesc": "缺少翻译的内容",
  "staff.localization.subtitle": "配置多语言应用内容",
  "staff.localization.tabs.categories": "产品分类",
  "staff.localization.tabs.completed": "已完成",
  "staff.localization.tabs.industries": "产品行业",
  "staff.localization.tabs.other": "其他内容",
  "staff.localization.tabs.pending": "待处理",
  "staff.localization.title": "本地化",
  "staff.nav.adminUsers": "管理员",
  "staff.nav.applications": "申请",
  "staff.nav.home": "首页",
  "staff.nav.invitations": "邀请",
  "staff.nav.localization": "本地化",
  "staff.nav.profile": "个人",
  "staff.users.actions.addNewUser": "添加新用户",
  "staff.users.actions.deactivateUser": "停用用户",
  "staff.users.actions.reactivateUser": "重新激活用户",
  "staff.users.deactivate.title": "停用用户",
  "staff.users.deactivate.body": "您确定要停用 {name} 吗？他们将无法再登录。",
  "staff.users.deactivate.confirm": "停用",
  "staff.users.deactivate.cancel": "取消",
  "staff.users.deactivate.success": "用户已停用",
  "staff.users.deactivate.successBody": "该用户的账户已被停用，他们将无法再登录。",
  "staff.users.reactivate.title": "重新激活用户",
  "staff.users.reactivate.body": "您确定要重新激活 {name} 吗？他们将能够再次登录。",
  "staff.users.reactivate.confirm": "重新激活",
  "staff.users.reactivate.cancel": "取消",
  "staff.users.reactivate.success": "用户已重新激活",
  "staff.users.reactivate.successBody": "该用户的账户已被重新激活，他们现在可以登录了。",
  "staff.users.detail.activity.empty": "未找到活动记录。",
  "staff.users.detail.activity.to": "改为",
  "staff.users.detail.addedBy": "添加者",
  "staff.users.detail.adminInfo": "行政信息",
  "staff.users.detail.breadcrumb": "管理员用户",
  "staff.users.detail.dateAdded": "添加日期",
  "staff.users.detail.editUser": "编辑用户",
  "staff.users.detail.emailAddress": "电子邮件地址",
  "staff.users.detail.firstName": "名",
  "staff.users.detail.languagePreference": "语言偏好",
  "staff.users.detail.lastActivity": "最后活动",
  "staff.users.detail.lastLogin": "最后登录 {time}（{date}）",
  "staff.users.detail.lastModified": "最后修改",
  "staff.users.detail.lastName": "姓",
  "staff.users.detail.personalInfo": "个人信息",
  "staff.users.detail.phoneNumber": "电话号码",
  "staff.users.detail.role": "角色",
  "staff.users.detail.tabs.activity": "活动日志",
  "staff.users.detail.tabs.profile": "个人资料信息",
  "staff.users.empty": "未找到用户。",
  "staff.users.modal.addButton": "添加用户",
  "staff.users.modal.addSuccess": "管理员用户已添加",
  "staff.users.modal.addSuccessBody": "该用户将收到一封登录 AladdinMiles 账户的电子邮件。",
  "staff.users.modal.addTitle": "添加新管理员用户",
  "staff.users.modal.editSuccess": "管理员用户已更新",
  "staff.users.modal.editSuccessBody": "用户资料已成功更新。",
  "staff.users.modal.editTitle": "编辑管理员用户",
  "staff.users.modal.rolePlaceholder": "选择角色",
  "staff.users.modal.saveButton": "保存更改",
  "staff.users.stats.active": "活跃用户",
  "staff.users.stats.activeDesc": "当前在仪表板上活跃",
  "staff.users.stats.disabled": "已禁用用户",
  "staff.users.stats.disabledDesc": "无法再访问仪表板",
  "staff.users.stats.inactive": "非活跃用户",
  "staff.users.stats.inactiveDesc": "当前在仪表板上非活跃",
  "staff.users.subtitle": "查看团队成员及其角色",
  "staff.users.table.lastActivity": "最近活动",
  "staff.users.table.role": "角色",
  "staff.users.table.status": "状态",
  "staff.users.table.user": "用户",
  "staff.users.tabs.active": "活跃",
  "staff.users.tabs.disabled": "已禁用",
  "staff.users.tabs.inactive": "非活跃",
  "staff.users.title": "管理员用户",
  "successState.description": "操作已成功完成。",
  "successState.title": "成功",
  "toast.a11y.error": "错误",
  "toast.a11y.info": "提示",
  "toast.a11y.success": "成功",
  "ui.checkbox.defaultA11y": "复选框",
  "ui.login.showcaseA11y": "打开组件演示",
  "ui.tag.addA11y": "添加新项目",
  "ui.tag.removeA11y": "移除 {label}",
  "vendor.application.companyInfo.dateApproved": "批准日期",
  "vendor.application.companyInfo.dateSubmitted": "提交日期",
  "vendor.application.companyInfo.lastActivity": "最后活动",
  "vendor.application.companyInfo.primaryIndustry": "主要行业",
  "vendor.application.detail.allFieldsApproved": "所有字段已通过审核",
  "vendor.application.detail.allFieldsReviewed": "所有字段均已审核",
  "vendor.application.detail.allFieldsUnderReview": "所有字段正在审核中",
  "vendor.application.detail.fieldRejected": "已拒绝",
  "vendor.application.detail.fieldUpdateRequired": "需要更新",
  "vendor.application.detail.fieldUpdated": "已更新",
  "vendor.application.detail.fieldsFlaggedForUpdate": "个字段已被标记需要更新",
  "vendor.application.detail.makeUpdate": "进行更新",
  "vendor.application.detail.notUploaded": "未上传",
  "vendor.application.detail.showQrCode": "显示二维码",
  "vendor.application.detail.tab.alipay": "支付宝",
  "vendor.application.detail.tab.bank": "银行",
  "vendor.application.detail.tab.wechatPay": "微信支付",
  "vendor.application.detail.financialSettlement.empty.title": "暂无结算信息",
  "vendor.application.detail.financialSettlement.empty.description": "该支付方式未提供任何付款信息。",
  "vendor.application.detail.viewDocument": "查看文件",
  "vendor.application.detail.viewImage": "查看图片",
  "vendor.application.stages.brandingLocalization": "品牌与本地化",
  "vendor.application.stages.businessInformation": "企业信息",
  "vendor.application.stages.completed": "已完成",
  "vendor.application.stages.financialSettlement": "财务结算",
  "vendor.application.stages.inProgress": "进行中",
  "vendor.application.stages.legalRepresentative": "法定代表人",
  "vendor.application.stages.notStarted": "未开始",
  "vendor.application.stages.productCompliance": "产品与合规",
  "vendor.application.stages.title": "申请阶段",
  "vendor.application.stages.updateRequired": "需要更新",
  "vendor.application.subtitle": "您申请的各部分摘要",
  "vendor.application.update.breadcrumb": "提交更新",
  "vendor.application.update.confirmBody": "您确定要提交的信息正确吗？",
  "vendor.application.update.confirmTitle": "提交更新",
  "vendor.application.update.correction": "更正",
  "vendor.application.update.correctionPlaceholder": "输入正确值",
  "vendor.application.update.newDocument": "新文件",
  "vendor.application.update.reviewerNote": "审核员备注",
  "vendor.application.update.sectionTitle": "更新提交",
  "vendor.application.update.submitUpdate": "提交更新",
  "vendor.application.update.successDescription": "您的更新已提交，我们的团队将很快审核。",
  "vendor.application.update.successTitle": "更新已提交",
  "vendor.application.update.yesSubmit": "是，提交",
  "vendor.application.update.yourSubmission": "您的提交",
  "vendor.approved.body": "恭喜！您的申请已获批准。",
  "vendor.approved.contactSupport": "需要帮助？联系客服。",
  "vendor.approved.credentialsNote": "请使用注册时设置的邮箱和密码登录。",
  "vendor.approved.portalLink": "进入商家门户",
  "vendor.approved.title": "申请已通过",
  "vendor.dashboard.applicationStatus": "您的申请状态",
  "vendor.dashboard.approvedOn": "批准于 {date}",
  "vendor.dashboard.approvedState.cta": "前往商户门户",
  "vendor.dashboard.approvedState.description": "您的供应商账户已激活。您将收到一封包含入驻步骤的欢迎邮件。",
  "vendor.dashboard.approvedState.title": "恭喜！",
  "vendor.dashboard.emptyState.description": "您的申请正在审核中。有任何更新我们会及时通知您。",
  "vendor.dashboard.emptyState.title": "暂无待办事项",
  "vendor.dashboard.nav.activity": "动态",
  "vendor.dashboard.nav.application": "申请",
  "vendor.dashboard.nav.home": "首页",
  "vendor.dashboard.nav.profile": "个人",
  "vendor.dashboard.nextSteps.approved.01.description": "使用上方按钮或批准邮件中的链接，登录 AladdinMiles 商户门户。",
  "vendor.dashboard.nextSteps.approved.01.title": "登录商户门户",
  "vendor.dashboard.nextSteps.approved.02.description": "开始向为您的业务创建的目录中添加商品。",
  "vendor.dashboard.nextSteps.approved.02.title": "添加商品",
  "vendor.dashboard.nextSteps.approved.03.description": "及时接收并处理订单，确保客户满意度。",
  "vendor.dashboard.nextSteps.approved.03.title": "完成订单",
  "vendor.dashboard.nextSteps.decision.description": "您将收到一条通知，告知最终结果。",
  "vendor.dashboard.nextSteps.decision.title": "决定",
  "vendor.dashboard.nextSteps.review.description": "团队会核实您提交的文件和信息",
  "vendor.dashboard.nextSteps.review.title": "审核",
  "vendor.dashboard.nextSteps.title": "后续步骤",
  "vendor.dashboard.nextSteps.validation.description": "核查营业执照及合规证书。",
  "vendor.dashboard.nextSteps.validation.title": "验证",
  "vendor.dashboard.pendingUpdates.fieldsToUpdate": "需更新 {count} 个字段",
  "vendor.dashboard.pendingUpdates.title": "待处理更新",
  "vendor.dashboard.pendingUpdates.noFieldsSpecified": "您的审核员未指定需要更新的字段，请联系他们以获取更多信息。",
  "vendor.dashboard.rejectedDocuments.rejected": "已拒绝",
  "vendor.dashboard.rejectedDocuments.title": "被拒绝的文件",
  "vendor.dashboard.rejectedDocuments.viewDocument": "查看文档",
  "vendor.dashboard.rejectedDocuments.viewReason": "查看原因",
  "vendor.dashboard.rejectedOn": "拒绝于 {date}",
  "vendor.dashboard.rejectedState.contactSupport": "联系支持",
  "vendor.dashboard.rejectedState.defaultDescription": "您的申请未获批准。如需更多信息，请联系支持团队。",
  "vendor.dashboard.rejectedState.title": "拒绝原因",
  "vendor.dashboard.status.approved": "已批准",
  "vendor.dashboard.status.notApproved": "未批准",
  "vendor.dashboard.status.pending": "待处理",
  "vendor.dashboard.status.updateRequired": "需要更新",
  "vendor.dashboard.step.approve": "批准",
  "vendor.dashboard.step.review": "审核",
  "vendor.dashboard.step.submitted": "已提交",
  "vendor.dashboard.submittedOn": "提交于 {date}",
  "vendor.dashboard.subtitle": "以下是您申请的最新状态。",
  "vendor.dashboard.title": "首页",
  "vendor.landing.changeLanguage": "更换语言",
  "vendor.landing.contactSupport": "联系客服",
  "vendor.landing.getStarted": "开始申请",
  "vendor.landing.needHelp": "需要帮助？",
  "vendor.landing.subtitle": "加入 AladdinMiles 专属供应商网络，深入拓展沙特阿拉伯市场。我们将您的业务与忠实消费者相连接，把他们的日常消费转化为旅行奖励。",
  "vendor.landing.title": "与 AladdinMiles 共同拓展您的业务",
  "vendor.languageSelect.appName": "AladdinMiles",
  "vendor.languageSelect.savePreference": "保存设置",
  "vendor.languageSelect.title": "选择您的首选语言",
  "vendor.languageSelect.welcomeTo": "欢迎使用",
  "vendor.pendingReview.body": "感谢您提交申请。我们的团队将在 1—3 个工作日内完成审核。如有任何问题，我们将及时迎接您。",
  "vendor.pendingReview.contactTitle": "如有疑问或需要帮助？",
  "vendor.pendingReview.step.approveApplication": "申请审核",
  "vendor.pendingReview.step.completed": "已完成",
  "vendor.pendingReview.step.createAccount": "创建账户",
  "vendor.pendingReview.step.pending": "待定",
  "vendor.pendingReview.step.rejected": "已拒绝",
  "vendor.pendingReview.step.rejectedApplication": "已拒绝申请",
  "vendor.pendingReview.step.submitApplication": "提交申请",
  "vendor.pendingReview.supportEmail": "vendors@aladdinmiles.com",
  "vendor.pendingReview.supportPhone": "+971 4 123 4567",
  "vendor.pendingReview.title": "我们正在审核您的申请",
  "vendor.rejected.body": "很遗憾，您的申请未获批准。请查看邮件了解详情。",
  "vendor.rejected.title": "申请未获批准",
  "vendor.activity.title": "动态",
  "vendor.activity.subtitle": "您申请的每次更新记录",
  "vendor.activity.allActivities": "所有动态",
  "vendor.activity.event.applicationApproved.title": "申请已批准",
  "vendor.activity.event.applicationApproved.description": "您的申请已审核并获批准。",
  "vendor.activity.event.applicationRejected.title": "申请未获批准",
  "vendor.activity.event.applicationRejected.description": "您的申请已审核但未获批准。",
  "vendor.activity.event.applicationReceived.title": "申请已收到",
  "vendor.activity.event.applicationReceived.description": "所有五个部分均已提交",
  "vendor.activity.event.updateRequired.title": "需要更新",
  "vendor.activity.event.updateRequired.description": "在审核继续之前，需要您关注某些字段。",
  "vendor.activity.event.updateSubmitted.title": "更新已提交",
  "vendor.activity.event.updateSubmitted.description": "您的更新已提交"
}
